import { Component } from '@angular/core';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// /dist/src/app/user/user.component.ts